import React, {Component} from 'react';
import {connect} from 'react-redux';
import {removeNotification} from '../actions';
//import {Grid, Col, Row} from 'react-bootstrap';
import NavBar from './NavBar';
//import Footer from './Footer';
import {hasLocalStorageUser} from '../auth';
import {AlertList} from 'react-bs-notifier';

class App extends Component {

    render() {
        //console.log('this.props.notifications', this.props.notifications)

        return (
            <div className="App">

                <div className="main-padding">

                    <AlertList
                        timeout={4000}
                        alerts={this.props.notifications || []}
                        onDismiss={(alert) => {this.props.dispatch(removeNotification(alert))}}
                    />

                    <NavBar loggedIn={hasLocalStorageUser()} user={this.props.ETMSUser} />

                    {this.props.children}

                </div>

            </div>
        );
    }

}

App = connect((state) => {
    return {
        ETMSUser: (state.data || {}).ETMSUser,
        notifications: (state.data || {}).notifications
    }
})(App);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx